<template>
  <div></div>
</template>

<script>

export default {

  data() {
    return {
    };
  },
  created() {
    const url = window.location.href;
    const tokenStart = url.indexOf('vm_token='); // 找到 'vm_token=' 后的索引位置
    if (tokenStart !== -1) {
      const tokenEnd = url.indexOf('&', tokenStart); // 找到下一个 '&' 的索引位置
      const token = url.substring(tokenStart + 9, tokenEnd !== -1 ? tokenEnd : undefined); // 提取 'vm_token=' 后面的值
      localStorage.setItem('vm_token', token); // 将 token 存储到 localStorage 中

         this.$router.push('/original');
    } else {

    }
  },
  mounted() {
  },
  methods: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/login/index.vue